
window.d = {
  priceP1: 5000,
  priceP2: 1.08,
  effectP1: 0.1,
  effectP2: 5
}


SJ._BasicItem =
  class {
    constructor(itemName, imageName, description, price) {
      this.itemName = itemName;
      this.description = description;
      this.imageName = imageName;
      this.price = Math.floor(price);
    }
  }

SJ.Item =
  class extends SJ._BasicItem {
    constructor(
      id,
      itemName,
      imageName,
      changedVarName,
      increment,
      description,
      level = 0,
      priceP1 = 5000, priceP2 = 1.08, effectP1 = 0.1, effectP2 = 5,
      orderNumberInShop
    ) {
      super(itemName, imageName, description, priceP1 * Math.pow(priceP2, (level + 1)));

      this.id = id;

      this.isActiveItem = false;
      this.changedVarName = changedVarName;

      // console.log(SJ.V[this.changedVarName]);
      // console.log(this.defaultVarValue);
      // console.log('');

      this.priceP1 = priceP1;
      this.priceP2 = priceP2;

      this.effectP1 = effectP1;
      this.effectP2 = effectP2;

      this.increment = parseInt(increment);

      this.runOfLuckLevel = 0;
      this.runOfLuckPoints = 0;
      this.isRunOfLuckActive = false;

      this.orderNumberInShop = orderNumberInShop;

      this.setItemLevel();
      this.setRunOfLuck();

      this.calculateVariables();
    }

    calculateVariables() {
      this.varMult = this.getVarMult(this.level);
      this.price = this.priceP1 * Math.pow(this.priceP2, (this.level + 1));

      if (SJ.playerData.data['isVip']) {
        this.price *= 0.95;
      }

      this.price = Math.floor(this.price);
    }

    //MULTIPLY VARIABLE
    equip() {

      if (this.increment === 1) {
        SJ.V[this.changedVarName] *= this.varMult / 100 + 1;
      }
      else {
        SJ.V[this.changedVarName] *= (100 - this.varMult) / 100;
      }

      if (SJ.playerData.data['name'] !== 'Guest') {
        this.checkLevelCorrectness();
        this.checkRunOfLuckCorrectness();
      }

      console.log(`${this.changedVarName}:`);
      console.log(`default value: ${this.defaultVarValue}`);
      console.log(`after equip: ${SJ.V[this.changedVarName]}`);
      console.log('-----');

    }

    //SET DEFAULT VAR VALUE
    unequip() {
      SJ.V[this.changedVarName] = this.defaultVarValue;
    }

    setDefaultVarValue() {
      this.defaultVarValue = SJ.V[this.changedVarName];
    }

    getVarMult(lvl) {
      return Math.floor(Math.log(1 + this.effectP1 * (lvl)) / Math.log(this.effectP2) * 1000) / 10;
    }

    setItemLevel() {

      if (SJ.playerData.data['name'] !== 'Guest') {
        fetch(`${SJ.APILink}item/getItemLevel.php?itemId=${this.id}&userName=${SJ.playerData.data['name']}`)
          .then(res => {
            return res.json();
          })
          .then(res => {
            this.level = parseInt(res[0]['lvl']);
            this.calculateVariables();
          })
      }
      else {
        const lvl10items = ['skis', 'helmet', 'gloves', 'goggles'];
        const lvl20items = ['boots', 'suit'];
        const megaPassItems = ['skis', 'boots', 'suit'];

        this.level = (lvl10items.includes(this.id)) ? 15 : (lvl20items.includes(this.id)) ? 25 : 20;

        if (megaPassItems.includes(this.id)) {
          this.runOfLuckLevel = 6;
          this.runOfLuckPoints = 5;
        }

        this.calculateVariables();
      }

    }

    checkLevelCorrectness() {
      if (SJ.playerData.data['name'] !== 'Guest') {
        fetch(`${SJ.APILink}item/getItemLevel.php?itemId=${this.id}&userName=${SJ.playerData.data['name']}`)
          .then(res => {
            return res.json();
          })
          .then(res => {
            if (this.level !== parseInt(res[0]['lvl'])) {
              console.log('%c THERE IS DISAGREEMENT IN LOCAL LEVEL OF ITEM AND LEVEL IN DATABASE', 'color: red');

              this.level = parseInt(res[0]['lvl']);

              this.unequip();
              this.equip();

            }
          })
      }
    }

    setRunOfLuck() {
      if (SJ.playerData.data['name'] !== 'Guest') {
        fetch(`${SJ.APILink}item/getItemRunOfLuck.php?itemId=${this.id}&userName=${SJ.playerData.data['name']}`)
          .then(res => { return res.json() })
          .then(res => {
            this.runOfLuckLevel = parseInt(res['runOfLuckLevel']);
            this.runOfLuckPoints = parseInt(res['runOfLuckPoints']);
          })
      }
    }

    checkRunOfLuckCorrectness() {

      if (SJ.playerData.data['name'] !== 'Guest') {
        fetch(`${SJ.APILink}item/getItemRunOfLuck.php?itemId=${this.id}&userName=${SJ.playerData.data['name']}`)
          .then(res => { return res.json() })
          .then(res => {

            if (this.runOfLuckLevel !== parseInt(res['runOfLuckLevel'])) {
              this.runOfLuckLevel = parseInt(res['runOfLuckLevel']);
              console.log('%c THERE IS DISAGREEMENT IN LOCAL KARMA LEVEL OF ITEM AND LEVEL IN DATABASE', 'color: red');
            }

            if (this.runOfLuckPoints !== parseInt(res['runOfLuckPoints'])) {
              this.runOfLuckPoints = parseInt(res['runOfLuckPoints']);
              console.log('%c THERE IS DISAGREEMENT IN LOCAL KARMA POINTS OF ITEM AND DATA IN DATABASE', 'color: red');
            }

          })
      }
    }

    equipItemWithRunOfLuck() {

      this.unequip();
      this.varMult = this.getVarMult(this.level + this.runOfLuckLevel);

      if (this.increment === 1) {
        SJ.V[this.changedVarName] *= this.varMult / 100 + 1;
      }
      else {
        SJ.V[this.changedVarName] *= (100 - this.varMult) / 100;
      }
    }

    activateRunOfLuck() {
      if (this.runOfLuckPoints > 0) {

        fetch(`${SJ.APILink}run-of-luck/activateRunOfLuck.php?userName=${SJ.playerData.data['name']}&itemId=${this.id}`)
          .then(res => { return res.json() })
          .then(res => {
            if (res === 'CORRECT') {
              this.equipItemWithRunOfLuck();

              this.runOfLuckPoints -= 1;

              if (this.runOfLuckPoints === 0)
                this.runOfLuckLevel = 0;

              this.isRunOfLuckActive = true;

              SJ.itemsDisplay.updateItemButtons();

              console.log('');
              console.log(`%c RunOfLuck activated on ${this.id}`, 'color: red');
              console.log(`Cur ${this.changedVarName} value: ${SJ.V[this.changedVarName]}`);
              console.log('');
            }
            else if (res === 'INCORRECT') {
              console.log(`%c There is no more runOfLuck points in database`, 'color: red');
            }
          })
      } else {
        console.log(`%c There is no more runOfLuck points for ${this.id}`, 'color: red');
      }

    }

    deactivateRunOfLuck() {
      this.unequip();
      this.varMult = this.getVarMult(this.level);
      this.equip();

      this.isRunOfLuckActive = false;

      SJ.itemsDisplay.updateItemButtons();
    }

  }

SJ.ActiveItem =
  class extends SJ._BasicItem {
    constructor(itemName, description, price, activateFunc, afterActivateFunc) {
      super(itemName, description, price);

      this.isActiveItem = true;
      this.activate = activateFunc;
      this.afterActivate = afterActivateFunc || (() => {
        this.isActive = true;
        this.disabled = true;
      });

      this.reset();
    }

    reset() {
      this.isActive = false;
      this.disabled = false;
    }

  }
